import PowerWordsIndicator from './PowerWordsIndicator';
export default PowerWordsIndicator;
